import { RegionEnum } from '@common/enums/region.enum';
import { IEnvironment } from '@core/interfaces/environment.interface';

/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/
export const environment: IEnvironment = {
  environment: 'production',
  projectId: 'linkhms',
  production: true,
  isServer: false,
  serverUrl: 'https://app.linkhms.com/api/v1',
  socketGatewayUrl: 'wss://app.linkhms.com',
  getFlowChartPeriod: 5000, // milliseconds
  dateFormat: 'yyyy-LL-dd',
  dateTimeFormat: 'yyyy-LL-dd H:mm',
  googleAnalyticsKey: 'G-DBC4G10BLD',
  googleTagManagerId: 'GTM-PSFZ92HW',
  crispWebsiteId: 'c66ef411-45f4-4b59-aa44-bf8013d62685',
  facebookPixelCode: '1106427170592490',
  googleClientId: '609427711699-ufsqve7khrf21ds9vmntakb3kvm5dn7l.apps.googleusercontent.com',
  sentryDsn:
    'https://951da65ee9645e15744c822fc580c554@o4510073543327744.ingest.de.sentry.io/4510759276249168',
  mixpanelToken: 'ab3ffec6dc5709e8d00891ec7da573b0',
  analyticsEnabled: true,
  deploymentRegion: 'af',
  availableRegions: [RegionEnum.af, RegionEnum.eu],
  mixpanelApiHost: 'https://api-eu.mixpanel.com',
};
